import { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useOutletContext, useParams } from 'react-router-dom';

import { MasterIndexApi } from '@/api';
import { withLoader, WithLoaderProps } from '@/hocs';
import { MasterVehicleFormData } from '@/layouts/TabLayout/MasterVehicles/components/MasterVehicleForm';
import {
  buildMasterVehicleTitle,
  normalizeMasterVehicleFormValues,
} from '@/layouts/TabLayout/MasterVehicles/licensePlate.utils';
import { IMasterVehicle } from '@/models';
import MasterVehicleForm from '@/pages/MasterIndex/Vehicles/components/MasterVehicleForm';
import { useToastStore } from '@/store';

import { MasterIndexDetailsContext } from '../../components/MasterIndexDetailsPage';

const MasterVehicleEdit: FC<WithLoaderProps> = () => {
  const outletContext = useOutletContext<
    MasterIndexDetailsContext | undefined
  >();
  const setCustomTitle = outletContext?.setCustomTitle;
  const setLastUpdatedAt = outletContext?.setLastUpdatedAt;
  const { updateToast } = useToastStore();
  const urlParams = useParams();

  const methods = useForm<MasterVehicleFormData>({
    defaultValues: {
      make: '',
      model: '',
      isVerified: false,
    },
    mode: 'all',
  });

  const { reset } = methods;

  const vehicleId =
    urlParams.vehicleId !== 'new' ? urlParams.vehicleId : undefined;

  useEffect(() => {
    if (vehicleId) fetchVehicleData();
    else reset();
  }, [vehicleId]);

  const fetchVehicleData = async () => {
    try {
      const promises = [MasterIndexApi.getMasterVehicle(vehicleId || '')];
      const [res] = await Promise.all(promises);
      const vehicle = res.data as IMasterVehicle;
      if (res.data.uniqueId && setCustomTitle) {
        const customTitle = buildMasterVehicleTitle(res.data);
        setCustomTitle(customTitle);
      }
      setLastUpdatedAt?.(res.data?.updatedAt);
      reset(normalizeMasterVehicleFormValues(vehicle));
    } catch (err: any) {
      updateToast({ open: true, message: err.message });
    }
  };

  return (
    <FormProvider {...methods}>
      <MasterVehicleForm />
    </FormProvider>
  );
};

export default withLoader(MasterVehicleEdit);
